/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GCSRestoreDestination } from '../models/GCSRestoreDestination';
import { QueryDBRestoreDestinationType } from '../models/QueryDBRestoreDestinationType';
import { S3RestoreDestination } from '../models/S3RestoreDestination';
import { StorageAccountContainerRestoreDestination } from '../models/StorageAccountContainerRestoreDestination';

export class QueryDBRestoreDestination {
  'destinationType'?: QueryDBRestoreDestinationType;
  's3Bucket'?: S3RestoreDestination | null;
  'gcsBucket'?: GCSRestoreDestination | null;
  'storageAccount'?: StorageAccountContainerRestoreDestination | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "destinationType",
      "baseName": "destinationType",
      "type": "QueryDBRestoreDestinationType",
      "format": ""
    },
    {
      "name": "s3Bucket",
      "baseName": "s3Bucket",
      "type": "S3RestoreDestination",
      "format": ""
    },
    {
      "name": "gcsBucket",
      "baseName": "gcsBucket",
      "type": "GCSRestoreDestination",
      "format": ""
    },
    {
      "name": "storageAccount",
      "baseName": "storageAccount",
      "type": "StorageAccountContainerRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return QueryDBRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}



